import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import StatsAPI from "@/src/api/StatsAPI";

import ExportCsvButton from "../../charts/ExportCsvButton";
import TimelineQueryCard from "../../charts/TimelineQueryCard";
import { signupsAndSubscriptionsQuery } from "../dashboard.queries";
import { buildSignupsTimeline } from "../dashboard.utils";

import type { JSX } from "react";

import type { GetSignupsAndSubscriptionsResponse } from "@/src/api/StatsAPI.types";

import type { ChartSeries, TimelineDatum } from "../../charts/charts.types";
import type {
  DashboardPeriodProps,
  SignupsSeriesKey,
} from "../dashboard.types";

function buildTimeline(
  response: GetSignupsAndSubscriptionsResponse | undefined,
): TimelineDatum<SignupsSeriesKey>[] {
  return buildSignupsTimeline(response?.data ?? []);
}

function SignupsTimelineCard({ period }: DashboardPeriodProps): JSX.Element {
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const { t } = useTranslation("editor-analytics");

  const seriesList = useMemo(
    (): ChartSeries<SignupsSeriesKey>[] => [
      {
        key: "signups",
        label: t("dashboard.series.signups"),
        color: "var(--chart-1)",
      },
    ],
    [t],
  );
  const fetchCsv = async (): Promise<BlobPart> =>
    StatsAPI.getSignupsAndSubscriptions({
      projectSlug,
      startDate: period.startDate,
      endDate: period.endDate,
      isExport: true,
    });

  return (
    <TimelineQueryCard
      buildTimeline={buildTimeline}
      endDate={period.endDate}
      query={signupsAndSubscriptionsQuery(projectSlug, period)}
      seriesList={seriesList}
      startDate={period.startDate}
      title={t("dashboard.charts.signups")}
      extraActions={
        <ExportCsvButton fetchCsv={fetchCsv} fileName="users.csv" />
      }
    />
  );
}

export default SignupsTimelineCard;
